module.exports = __webpack_public_path__ + "img/giphy.d71d8ccb.gif";